// /auth/agol/callback — handles the OAuth redirect from NIFC AGOL.
// We exchange the auth code for tokens, then send the user back where
// they came from.

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleCallback } from '../lib/agol-auth';
import { useAgolAuthStore } from '../stores/agolAuthStore';

export default function AuthCallback() {
  const nav = useNavigate();
  const hydrate = useAgolAuthStore((s) => s.hydrate);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const returnTo = await handleCallback();
        await hydrate();
        if (!cancelled) nav(returnTo, { replace: true });
      } catch (e: any) {
        if (!cancelled) setError(e?.message ?? String(e));
      }
    })();
    return () => { cancelled = true; };
  }, [nav, hydrate]);

  return (
    <div className="absolute inset-0 flex items-center justify-center text-center p-6">
      <div className="max-w-sm">
        {error ? (
          <>
            <h2 className="text-cockpit-100 font-semibold mb-2">NIFC sign-in failed</h2>
            <p className="text-sm text-red-400 break-words mb-4">{error}</p>
            <button
              onClick={() => nav('/settings', { replace: true })}
              className="text-sm bg-cockpit-700 border border-cockpit-600 rounded-md px-3 py-1.5"
            >
              Back to Settings
            </button>
          </>
        ) : (
          <>
            <div className="inline-block animate-pulse text-3xl mb-3">🔐</div>
            <h2 className="text-cockpit-100 font-semibold">Signing in to NIFC ArcGIS Online…</h2>
          </>
        )}
      </div>
    </div>
  );
}
